import { render } from "./PostApprovalStep2.vue?vue&type=template&id=2df96457&scoped=true"
import script from "./PostApprovalStep2.vue?vue&type=script&lang=js"
export * from "./PostApprovalStep2.vue?vue&type=script&lang=js"

import "./PostApprovalStep2.vue?vue&type=style&index=0&id=2df96457&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df96457"]])

export default __exports__